"use client";

import { motion } from "framer-motion";
import { usePortfolio } from "@/components/portfolio-provider";

const DEFAULT_WHATSAPP_NUMBER = "8801540581443";
const DEFAULT_WHATSAPP_MESSAGE = "Hi Sakibul, I'd like to discuss a project.";

function WhatsAppIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      className={className}
    >
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.884 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

export default function WhatsAppFloat() {
  const { data } = usePortfolio();
  const config = data?.siteConfig;

  if (config && config.whatsappEnabled === false) {
    return null;
  }

  const number = (config?.whatsappNumber || DEFAULT_WHATSAPP_NUMBER).replace(
    /\D/g,
    "",
  );
  const text =
    config?.whatsappMessage || DEFAULT_WHATSAPP_MESSAGE;
  const whatsappUrl = `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.8, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.45, ease: "easeOut" }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] border border-white/30 text-white shadow-[0_10px_28px_rgba(37,211,102,0.4),inset_0_1px_1.5px_rgba(255,255,255,0.4)] transition-transform duration-200 hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#25D366] focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:bottom-8 sm:right-8 transform-gpu"
    >
      <span className="pointer-events-none absolute inset-0 rounded-full bg-[#25D366] opacity-35 animate-ping [animation-duration:2.5s]" />
      <span className="relative flex h-full w-full items-center justify-center rounded-full">
        <WhatsAppIcon className="h-7 w-7 drop-shadow-sm" />
      </span>
      <span className="pointer-events-none absolute right-full mr-3.5 hidden whitespace-nowrap rounded-full border border-white/15 bg-[#120e0a]/95 px-3.5 py-1.5 text-xs font-semibold text-foreground shadow-[0_10px_25px_rgba(0,0,0,0.5),inset_0_1px_1px_rgba(255,255,255,0.2)] opacity-0 transition-opacity duration-200 group-hover:opacity-100 sm:block">
        Chat on WhatsApp
      </span>
    </motion.a>
  );
}
